import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import Table from "../RevvTable";

// Actions Imports
import {
  updateDocumentClickedComponentID,
  updateDraggedSection,
} from "../../actions/DocumentActions/index";
import { QuotationActions } from "../../actions";

import { DOCUMENTS, COMMON } from "../../constants";
// Destructuring
const { DEAL_LABELS } = COMMON;
const { DOCUMENT_MODE } = DOCUMENTS;
const { toggleTabAndToolPanelData } = QuotationActions;

// Decalarations
const QUOTE_TABLE = "QUOTE_TABLE";

// eslint-disable-next-line react/prefer-stateless-function
class CustomQuoteTableWrapper extends Component {
  customQuoteTableWrapperRef = React.createRef();

  componentDidMount() {
    this.props.updateDraggedSection(null, null);
    if (
      this.customQuoteTableWrapperRef &&
      this.customQuoteTableWrapperRef.current &&
      this.props.isComponentActive
    ) {
      this.customQuoteTableWrapperRef.current.focus();
    }
  }

  _openDealTable = () => {
    if (!this.props.isSharedDocument) {
      this.props.toggleTabAndToolPanelData({
        tabView: QUOTE_TABLE,
        dealTableId: 0,
        isOpen: false,
        panelView: null,
        page: QUOTE_TABLE,
        showPriceBook: true,
      });
    }
  };

  _documentView = () => {
    const {
      section: { id },
      handleBlur,
      isSharedDocument,
    } = this.props;
    const headers = DOCUMENTS.DEALTABLE_COLUMNS.map(column => column.text);
    return (
      <div className="quote-table-wrapper" id={id}>
        {!isSharedDocument && (
          <div
            className="custom-dealtable-wrapper-headertitle"
            onKeyPress={() => {}}
            role="button"
            tabIndex="0"
            onClick={() => this._openDealTable()}>
            {"Add/modify products"}
          </div>
        )}

        <Table
          className="quotetable-wrapper"
          readOnly
          headers={headers}
          section={[]}
          handleBlur={handleBlur}
        />
        <div className="dealtable-deal-discount">
          <div className="dealtable-deal-discountwrapper">
            <div className="row dealtable-deal-value">
              <div className="col-md-8">Subtotal:</div>
              <div className="col-md-4">0</div>
            </div>
            <div className="row dealtable-deal-value">
              <div className="col-md-8">
                {DEAL_LABELS["deal-label"]} Discount(%):
              </div>
              <div className="col-md-4">{0}</div>
            </div>
            <div className="row dealtable-deal-value">
              <div className="col-md-8">
                {DEAL_LABELS["deal-label"]} Discount Value:
              </div>
              <div className="col-md-4">0</div>
            </div>
            <div className="row dealtable-deal-totalvalue">
              <div className="col-md-8">{DEAL_LABELS["deal-label"]} Total:</div>
              <div className="col-md-4">0</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  _templateView = () => {
    const {
      section: { id },
      handleBlur,
    } = this.props;
    const headers = DOCUMENTS.DEALTABLE_COLUMNS.map(column => column.text);
    const data = [DOCUMENTS.DEALTABLE_COLUMNS.map(() => "")];
    return (
      <div className="quotetable-placeholder-wrapper" id={id}>
        <div className="clause-product-name">{`${
          DEAL_LABELS["deal-table-label"]
        } Placeholder`}</div>
        <Table
          className="quotetable-wrapper"
          readOnly
          headers={headers}
          section={{ data }}
          handleBlur={handleBlur}
        />
        <div className="quotetable-placeholder">
          Quote table will be placed here when doc is created from this
          template. You can drag and rearrange position if needed from outlines.
        </div>
      </div>
    );
  };

  _handleOnClick = event => {
    event.preventDefault();
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive && section) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      if (this.props.createDocSectionRef) {
        this.props.createDocSectionRef(React.createRef());
      }
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    const { isComponentActive, preventClickedComponentIdUpdate } = this.props;
    if (isComponentActive && preventClickedComponentIdUpdate) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    return (
      <Fragment>
        <div
          ref={this.customQuoteTableWrapperRef}
          className={`customquotetable-component ${
            this.props.isComponentActive ? "active-customquotetable" : ""
          } `}
          onClick={this._handleOnClick}
          onKeyPress={() => {}}
          onBlur={this._handleOnBlur}
          role="button"
          tabIndex={0}>
          {this.props.mode === DOCUMENT_MODE.DOCUMENT
            ? this._documentView()
            : this._templateView()}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { section } = props;
  // check if the section is in active state or hovered state
  const {
    clickedActiveComponentId,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;
  const isComponentActive = clickedActiveComponentId === section.id;

  return {
    isComponentActive,
    preventClickedComponentIdUpdate,
  };
};
const mapDispatchToProps = {
  toggleTabAndToolPanelData,
  updateDocumentClickedComponentID,
  updateDraggedSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomQuoteTableWrapper);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomQuoteTableWrapper.js